import { render, staticRenderFns } from "./TabProfileCoverage.vue?vue&type=template&id=9ade4002&scoped=true"
import script from "./TabProfileCoverage.vue?vue&type=script&lang=js"
export * from "./TabProfileCoverage.vue?vue&type=script&lang=js"
import style0 from "./TabProfileCoverage.vue?vue&type=style&index=0&id=9ade4002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ade4002",
  null
  
)

export default component.exports